interface LogoProps {
  className?: string;
  // Per-org branded logo URL; falls back to the default Heymakr mark when absent.
  src?: string | null;
  alt?: string;
}

export default function Logo({ className = 'w-6 h-6', src, alt = 'Heymakr' }: LogoProps) {
  return (
    <img
      src={src || '/heymakr-logo.png'}
      alt={alt}
      className={`${className} object-contain`}
    />
  );
}
